module.exports = __webpack_public_path__ + "img/map_Z2.7.B.03.0a9e6c82.svg";